import React from 'react'
import "./privacy.css"; 

export const Privacypolicy = () => {
  return (
   <>
<section className="privacy-modern py-5">
  <div className="container">
    {/* Header */}
    <div className="text-center mb-5">
      <h1 className="main-title">Privacy Policy</h1>
      
    </div>
    {/* Intro */}
    <div className="privacy-card">
      <h4>Introduction</h4>
      <p>
        This Platform is owned by Topfaculty. This Privacy Policy pertains to the
        services made available at http://www.topfaculty.co.in  platforms.
      </p>
      <p>
        The Topfaculty Website are collectively referred to as
        "Platform". By using this Platform, you agree to the collection, use,
        and disclosure of your information in accordance with this policy.
      </p>
      <p>
        We are committed to safeguarding your information and ensuring
        transparency in how we handle your data.
      </p>
    </div>
    {/* Personal Info */}
    <div className="privacy-card">
      <h4>What is Personal Information and why do we collect it?</h4>
      <p>
        Personal Information means any information that identifies an
        individual, including name, email address, contact number, and other
        details.
      </p>
      <p>
        We collect this information to identify you, provide better services,
        improve your experience, and deliver personalized educational feedback.
      </p>
    </div>
    {/* Info Collection */}
    <div className="privacy-card">
      <h4>What Personal Information do we collect and how do we use it?</h4>
      <p>
        <b>1. Information you share:</b> Name, email, contact details, payment
        information, and usage data.
      </p>
      <p>
        <b>2. Cookies &amp; Tracking Technologies:</b> Used to enhance user
        experience and track activity.
      </p>
      <p>
        <b>3. Log Information:</b> Includes IP address, browser type, access
        time, and cookies.
      </p>
      <p>
        <b>4. User Communications:</b> Emails and messages stored for service
        improvement.
      </p>
      <p>
        <b>5. Links:</b> We are not responsible for third-party platforms.
      </p>
      <p>
        <b>6. Alerts:</b> Notifications via Email, SMS, Calls, WhatsApp.
      </p>
      <p>
        <b>7. Public Forums:</b> Shared data may become public.
      </p>
      <p>
        <b>8. Data Security:</b> Secure payment handling and protection.
      </p>
      <p>
        <b>9. Data Usage:</b> Administrative and technical safeguards applied.
      </p>
    </div>
    {/* Usage */}
    <div className="privacy-card">
      <h4>What we do with the information we gather?</h4>
      <ul>
        <li>Internal record keeping</li>
        <li>Improve products and services</li>
        <li>Send promotional emails</li>
        <li>Market research</li>
        <li>Customize platform experience</li>
      </ul>
    </div>
    {/* Retention */}
    <div className="privacy-card">
      <h4>For how Long Do We Retain User Data?</h4>
      <p>
        We retain user data while accounts are active and for at least three
        years afterward. Retention may vary based on legal and business
        requirements.
      </p>
    </div>
    {/* Security */}
    <div className="privacy-card">
      <h4>Security</h4>
      <p>
        We implement physical, electronic, and managerial procedures to protect
        your information. However, no system can guarantee complete security.
      </p>
    </div>
    {/* Children */}
    <div className="privacy-card">
      <h4>Children</h4>
      <p>
        We do not knowingly collect data from children under 13 without parental
        consent.
      </p>
    </div>
    {/* Links */}
    <div className="privacy-card">
      <h4>Links to other Platforms</h4>
      <p>
        Our platform may contain links to external websites. We are not
        responsible for their privacy practices.
      </p>
    </div>
    {/* Third Party */}
    <div className="privacy-card">
      <h4>Third Party Services</h4>
      <p>
        We may share data with trusted providers to improve services. We do not
        sell personal information.
      </p>
    </div>
    {/* Copyright */}
    <div className="privacy-card">
      <h4>Copyright</h4>
      <p>
        All content is protected under copyright laws and cannot be reused
        without permission.
      </p>
    </div>
    {/* Contact */}
    <div className="privacy-card">
      <h4>Contacting Us</h4>
      <p>
        For queries, please use the "Contact Us" section on our website.
      </p>
    </div>
    {/* Changes */}
    <div className="privacy-card">
      <h4>Changes to this Policy</h4>
      <p>
        We may update this policy from time to time. Please review it
        periodically.
      </p>
    </div>
    {/* Consent */}
    <div className="privacy-card">
      <h4>Your Consent to This Policy</h4>
      <p>
        By using our Platform, you agree to this Privacy Policy and its terms.
      </p>
    </div>
  </div>
</section>


</>

  )
}
